import { render, staticRenderFns } from "./ReleasesModal.vue?vue&type=template&id=4734e812&scoped=true&"
import script from "./ReleasesModal.vue?vue&type=script&lang=js&"
export * from "./ReleasesModal.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesModal.vue?vue&type=style&index=0&id=4734e812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4734e812",
  null
  
)

export default component.exports